import type { HomeChargingSupportingDocumentStatus } from "@qivia/ui";
import { HomeChargingSupportingDocument } from "./homeChargingSupportingDocumentsAPI";

export const getHomeChargingSupportingDocumentStatus = (
  supportingDocument: HomeChargingSupportingDocument,
  isCurrentMonth: boolean,
): HomeChargingSupportingDocumentStatus =>
  isCurrentMonth
    ? "CURRENT_MONTH"
    : supportingDocument.chargesCount === 0
      ? "NOTHING_TO_CREATE"
      : supportingDocument.supportingDocument
        ? "CREATED"
        : "TO_CREATE";
